/*
 * Copyright (c) 2016-2020 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { ClrCommonStrings } from './common-strings.interface';

export const commonStringsDefault: ClrCommonStrings = {
  open: 'Open',
  close: 'Close',
  show: 'Show',
  hide: 'Hide',
  expand: 'Expand',
  collapse: 'Collapse',
  more: 'More',
  select: 'Select',
  selectAll: 'Select All',
  previous: 'Previous',
  next: 'Next',
  current: 'Jump to current',
  info: 'Info',
  success: 'Success',
  warning: 'Warning',
  danger: 'Error',
  rowActions: 'Available actions',
  pickColumns: 'Show or hide columns',
  showColumns: 'Show Columns',
  sortColumn: 'Sort Column',
  firstPage: 'First Page',
  lastPage: 'Last Page',
  nextPage: 'Next Page',
  previousPage: 'Previous Page',
  currentPage: 'Current Page',
  totalPages: 'Total Pages',
  minValue: 'Min value',
  maxValue: 'Max value',
  modalContentStart: 'Beginning of Modal Content',
  modalContentEnd: 'End of Modal Content',
  showColumnsMenuDescription: 'Show or hide columns menu',
  allColumnsSelected: 'All columns selected',
  signpostToggle: 'Signpost Toggle',
  signpostClose: 'Signpost Close',
  loading: 'Loading',
  // Datagrid
  detailPaneStart: 'Start of row details',
  detailPaneEnd: 'End of row details',
  singleSelectionAriaLabel: 'Single selection header',
  singleActionableAriaLabel: 'Single actionable header',
  detailExpandableAriaLabel: 'Toggle more row content',
  datagridFilterAriaLabel: 'Toggle column filter',
  // Alert
  alertCloseButtonAriaLabel: 'Close alert',
  // Date Picker
  datepickerToggle: 'Toggle datepicker',
  datepickerPreviousMonth: 'Previous month',
  datepickerCurrentMonth: 'Current month',
  datepickerNextMonth: 'Next month',
  datepickerPreviousDecade: 'Previous decade',
  datepickerNextDecade: 'Next decade',
  datepickerCurrentDecade: 'Current decade',
  datepickerSelectMonthText: 'Select month, the current month is {CALENDAR_MONTH}',
  datepickerSelectYearText: 'Select year, the current year is {CALENDAR_YEAR}',
  daypickerSRCurrentMonthPhrase: 'The current month is {CURRENT_MONTH}',
  daypickerSRCurrentYearPhrase: 'The current year is {CURRENT_YEAR}',
  daypickerSRCurrentDecadePhrase: 'The current decade is {DECADE_RANGE}',
  // Stack View
  stackViewChanged: 'Value changed.',
  // Forms
  formErrorSummary: 'The form has {ERROR_NUMBER} errors.',
  //Vertical Nav
  verticalNavToggle: 'Toggle vertical navigation',
  verticalNavGroupToggle: 'Toggle vertical navigation group',
  // Timeline steps
  timelineStepNotStarted: 'Not started',
  timelineStepCurrent: 'Current',
  timelineStepSuccess: 'Completed',
  timelineStepError: 'Error',
  timelineStepProcessing: 'In progress',

  // Datagrid expandable rows
  dategridExpandableBeginningOf: 'Beginning of',
  dategridExpandableEndOf: 'End of',
  dategridExpandableRowContent: 'Expandable row content',
  dategridExpandableRowsHelperText: `Screen reader table commands may not work for viewing expanded content, please use your screen reader's browse mode to read the content exposed by this button`,
};
